import { Injectable } from '@angular/core';

@Injectable()
export class NormeSpaDualisticoFieldValidators {
    // RULE: add here only validators that read ONLY the single control value.
    constructor() {}
}
